export default (state = {}, action)=>{
    switch(action.type){
        case "set-projection-data":
            return {templates: action.templates, data: action.data}
        default:
            return state;
    }
}
